let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fpfl8")).then(() => parcelRequire('aKsI4'));